import {
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_BEGIN,
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_SUCCESS,
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_FAILURE,
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function saveExternaldatabaseForSalesforce(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_BEGIN,
    });
    const { projectId, projectVersion } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${projectVersion}/salesforce/save-externaldata`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveExternaldatabaseForSalesforceError() {
  return {
    type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_BEGIN:
      return {
        ...state,
        saveExternaldatabaseForSalesforcePending: true,
        saveExternaldatabaseForSalesforceError: null,
      };

    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_SUCCESS:
      return {
        ...state,
        saveExternaldatabaseForSalesforcePending: false,
        saveExternaldatabaseForSalesforceError: null,
        externalDbUuid: action.data.uuid,
      };

    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_FAILURE:
      return {
        ...state,
        saveExternaldatabaseForSalesforcePending: false,
        saveExternaldatabaseForSalesforceError: action.data.error,
      };

    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_SALESFORCE_DISMISS_ERROR:
      return {
        ...state,
        saveExternaldatabaseForSalesforceError: null,
      };

    default:
      return state;
  }
}
